import * as React from "react";
import type { SVGProps } from "react";
const SvgWeather = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#weather_svg__a)">
      <path d="M15.09 13.77c-.2 0-.4-.06-.58-.19a.994.994 0 0 1-.23-1.39c.34-.47.51-1.03.51-1.61a2.791 2.791 0 1 0-5.23 1.36 1 1 0 0 1-1.74.98 4.74 4.74 0 0 1-.61-2.33C7.21 7.95 9.36 5.8 12 5.8s4.79 2.15 4.79 4.79c0 1-.31 1.96-.88 2.77a1 1 0 0 1-.82.42z" />
      <path d="M12 7.79c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v3.79c0 .55-.45 1-1 1" />
      <path d="M12 7.79c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v3.79c0 .55-.45 1-1 1" />
      <path d="M12 7.79c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v3.79c0 .55-.45 1-1 1M19.58 11.58h-3.79c-.55 0-1-.45-1-1s.45-1 1-1h3.79c.55 0 1 .45 1 1s-.45 1-1 1M8.21 11.58H4.42c-.55 0-1-.45-1-1s.45-1 1-1h3.79c.55 0 1 .45 1 1s-.45 1-1 1" />
      <path d="M7.9 16.86c-.42 0-.82-.27-.95-.7q-.21-.645-.21-1.32c0-2.38 1.94-4.32 4.32-4.32 1.58 0 3.04.87 3.79 2.26.26.49.08 1.09-.4 1.36-.49.26-1.09.08-1.36-.4a2.322 2.322 0 0 0-4.25 1.82 1 1 0 0 1-.65 1.26c-.1.03-.2.05-.3.05z" />
      <path d="M16.74 22H6.32C3.94 22 2 20.06 2 17.68s1.94-4.32 4.32-4.32c.65 0 1.27.14 1.85.42.5.24.71.83.47 1.33s-.83.71-1.33.47A2.322 2.322 0 0 0 4 17.68C4 18.96 5.04 20 6.32 20h10.42a3.26 3.26 0 0 0 0-6.52c-1.06 0-2.05.52-2.67 1.38-.32.45-.94.56-1.39.24a.996.996 0 0 1-.24-1.39 5.29 5.29 0 0 1 4.3-2.23c2.9 0 5.26 2.36 5.26 5.26S19.64 22 16.74 22M14.68 8.9c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l2.68-2.68a.996.996 0 1 1 1.41 1.41l-2.68 2.68c-.2.2-.45.29-.71.29zM9.32 8.9c-.26 0-.51-.1-.71-.29L5.93 5.93a.996.996 0 1 1 1.41-1.41l2.68 2.68a.996.996 0 0 1-.71 1.7z" />
    </g>
    <defs>
      <clipPath id="weather_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWeather;
